import { useState, useEffect } from "react";
import { loadUserGuideList, loadUserGuideListByID } from "../../services/UserGuideService";

const useUserGuideList = (status) => {

    const [guides, setGuides] = useState([]);
    const [sections, setSections] = useState([]);
    const [isWarehouseDataLoaded, setIsWarehouseDataLoaded] = useState(false);
    const [selectedGuide, setSelectedGuide] = useState(null);
    const [selectedGuidID, setSelectedGuideID] = useState(null);

    // Fetch department data
    const fetchUserGuideList = async (selectedID = null) => {
        try {
            let data;
            const para = {               
            };

            data = await loadUserGuideList(para);

            if (data && data.length > 0) {
                setGuides(data);
            }

        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    const fetchUserGuideListByID = async (selectedID = null) => {
        try {
            let data;
            const para = {
                p_user_guide_id: selectedID,
            };
            data = await loadUserGuideListByID(para);
            if (data && data.length > 0) {
                setSections(data);
            }

        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isWarehouseDataLoaded) {
            fetchUserGuideList();
        }
    }, [isWarehouseDataLoaded]);

    // Function to load department based on selected ID
    const loadWarehouseByID = async (selectedID) => {
        await fetchUserGuideList(selectedID);
    };

    return {
        guides,
        selectedGuide,
        selectedGuidID,
        setSelectedGuide,
        setSelectedGuideID,
        loadWarehouseByID,
        fetchUserGuideListByID,
        sections, setSections,
    };
};

export default useUserGuideList;
